import { useFetchListData } from '@/composables'
import { defineStore } from 'pinia'
import { computed } from 'vue'

const useAccountCurrencyStore = defineStore('accountCurrency', () => {
  const { data, loading, fetchData } = useFetchListData<string[]>({
    url: '/api/pub/get_account_currency',
    autoFetch: false,
    showErrorMessage: false,
  })

  const currencyOptions = computed(() => {
    if (!data.value) return []
    return data.value.map((item) => ({ label: item, value: item }))
  })

  const reset = () => {
    loading.value = false
    data.value = null
    _initPromise = null
  }

  let _initPromise: Promise<void> | null = null
  const init = async (params?: Record<string, any>) => {
    if (_initPromise) return _initPromise
    _initPromise = (async () => {
      if (Array.isArray(data.value) && data.value.length > 0) return
      await fetchData(params)
    })()
    return _initPromise
  }

  return {
    loading,
    data,
    currencyOptions,
    reset,
    init,
    fetchData,
  }
})

export default useAccountCurrencyStore
